export const text = {
  title: 'Admin Panel',
  accessDenied: 'Access denied',
  accessDeniedDescription: 'You do not have permission to view this page.',
  databaseManagement: 'Database Management',
  clearReseedWarning:
    'This will permanently delete all existing plants and replace them with default plants.',
  clearReseedButton: 'Clear & Reseed Plants',
  clearReseedTooltip: 'Wipes all plants and reseeds with default plant database',
  clearReseeding: 'Clearing & Seeding...',
  seedTemplateGarden: 'Seed Backyard Template Garden',
  seedTemplateGardenTooltip: 'Creates a pre-populated example garden for testing',
  seedSummerTemplateGarden: 'Seed Backyard Summer Template Garden',
  seedSummerTemplateGardenTooltip: 'Creates a pre-populated summer example garden for testing',
  creatingGarden: 'Creating Garden...',
  previewGardenInfo:
    'Creates a new garden with one of each default plant (that exists in the DB) so you can visually review plant images and design.',
  createPreviewGarden: 'Create Plant Image Preview Garden',
  previewGardenTooltip: 'Generate a showcase garden with every plant for visual review',
  creatingPreviewGarden: 'Creating Preview Garden...',
  currentPlants: 'Current Plants',
  noPlants: 'No plants in database. Click "Clear & Reseed Plants" to add default plants.',
  plantsTotal: (count: number) => `Total: ${count} plants`,
  clearConfirmTitle: 'Are you absolutely sure?',
  clearConfirmDescription:
    'This action cannot be undone. This will permanently delete all plants from the database and replace them with default plants.',
  clearConfirmAction: 'Yes, clear and reseed',
};
